Collection = require('./collection')
Model = require('./Model').default
Creatable = require('./Creatable')
Field = require('./Field')

module.exports = class Stereotype extends Model

    defaults:
        # previously anonymous attributes
        creatables: null
        fields: null

    initialize: =>
        @set("creatables", new Collection(@attributes.creatables, {model: Creatable}))
        @set("fields", new Collection(@attributes.fields, {model: Field, defaultKey: @attributes.defaultFieldKey}))

    getMagicRoot: =>
        if @get("magicRoot") == true || !@collection
            @
        else
            @collection.find (item)=>
                item.get('key') == @get("magicRootKey")

    getMagicRootEntityName: =>
        @getMagicRoot().get('name')



// WEBPACK FOOTER //
// ./app/models/Stereotype.coffee